module.exports = __webpack_public_path__ + "static/media/guitar.da19c4b9.jpg";